import { gql } from '@apollo/client'

export const userDraftRemoveByIdMutation = gql`
  mutation UserDraftRemoveById($_id: String!) {
    userDraftRemoveById(_id: $_id) {
      recordId
    }
  }
`
